module.exports = __webpack_public_path__ + "static/media/bj.e9dd13f2.png";